import { useCallback } from 'react';
import moment from 'moment';
import { useGetApiV1UnderwritingErrorsQuery } from '../api';
import { isDecisionModel, isDenyModel, isPriceModel } from '../api/api-types';
import { useGetApiV1UnderwritingModelsQuery } from '.';

export const defaultParams: { startDate: string; endDate: string } = {
    startDate: moment().add(-3, 'day').format('YYYY-MM-DD'),
    endDate: moment().add(1, 'day').format('YYYY-MM-DD'),
};

export const useModels = () => {
    const { isLoading, isFetching, data } = useGetApiV1UnderwritingModelsQuery({});

    const errors = useGetApiV1UnderwritingErrorsQuery(defaultParams);

    const getErrorNumByModelID = useCallback((n: number) => errors.data?.entities[n]?.errors?.length ?? 0, [errors]);
    const buildTableModels = useCallback(() => {

        return !isLoading && data
            ? data.ids.map((i) => {
                  // TODO: fix this
                  const x = data.entities[i];
                  return {
                      modelID: x?.modelId,
                      name: `${x?.name}` ?? 'Unnamed model',
                      groupWeight: x?.groupWeight,
                      // sortOrder: x.sortOrder,
                      activePeriod: [moment(x?.activeStart), moment(x?.activeEnd)],
                      groupID: x?.groupId,
                      modelType: x?.modelType,
                      priceRange: x && isPriceModel(x) ? [x.price?.minAmount, x.price?.maxAmount] : null,
                      preReqs: x?.preReqs ?? [],

                      denyRules: x && isDenyModel(x) ? x.denyRules : undefined,

                      approve:
                          x && isDecisionModel(x) ? [x.decision?.acceptSymbol, x.decision?.acceptLimit] : undefined,
                      apr: 0, //x.apr,
                      product: [], //x.product,
                      principal: [x?.lowAmount, x?.highAmount],

                      unabletoUnderwrite: [],
                      errors: getErrorNumByModelID(x?.modelId ?? 0),
                      history: [],
                  };
              })
            : [];
    }, [isLoading, data, getErrorNumByModelID]);

    const sortModel = (modelID: number, orderDest: number) => { };
    return {
        models: buildTableModels(),
        isFetching,
        sortModelAsync: sortModel,
        errors: {
            ...errors,
            runGetErrors: useGetApiV1UnderwritingErrorsQuery,
            calculateErrorCount: getErrorNumByModelID,
        },
    };
};
